import operation from '@/api/vehicle-operation'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  employees: [],
  zones: [],
  vehicles: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },

  SET_EMPLOYEE(state, data) {
    state.employees = data
  },

  SET_ZONE(state, data) {
    state.zones = data
  },

  SET_VEHICLE(state, data) {
    state.vehicles = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return operation.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return operation.store(data)
  },

  update(context, data) {
    return operation.update(data)
  },

  destroy(context, id) {
    return operation.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await operation.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.employees.length > 0) {
      let response = await operation.getEmployee()
      context.commit('SET_EMPLOYEE', response)
    }
    if (!context.state.zones.length > 0) {
      let response = await operation.getZone()
      context.commit('SET_ZONE', response)
    }
    if (!context.state.vehicles.length > 0) {
      let response = await operation.getVehicle()
      context.commit('SET_VEHICLE', response)
    }
  }
}
